export const MuiCard = {
  styleOverrides: {
    root: {
      backgroundColor: "#1c1c1c",
    },
  },
};
